/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { Button } from 'reactstrap';
import G17EcoLogo from '../../images/g17Eco.svg';
import UserDetail from './user-detail';
import LoginButton from './LoginButton';
import AppsMenu from './AppsMenu';
import SimpleTooltip from '../simple-tooltip';
import RequestDemoModal from '../request-demo-modal';
import { match, useHistory, useRouteMatch } from 'react-router-dom';
import { useAppSelector } from '../../reducers';
import { OrgSwitcherInitiative, OrganizationSwitcher } from '../initiative/OrganizationSwitcher';
import Notifications from './notifications';
import { getDefaultConfig } from '../../config/app-config';
import { TodoWidget } from '../todo/TodoWidget';
import { AppRootMatcher } from '../../routes/appRootMatcher';

export interface G17EcoHeaderProps {
  brandingLogo?: string
  displayRootSwitcher?: boolean
  routeMatcher?: AppRootMatcher,
  rootInitiatives?: OrgSwitcherInitiative[];
}

const { rootAppPath, whitelabel, homeUrl } = getDefaultConfig().branding.ctlApp;

const getHeaderLogo = (brandingLogo: string | undefined, url: match<{ rootAppPath?: string }> | null) => {
  if (brandingLogo) {
    return brandingLogo
  }

  if (whitelabel?.logo && url?.params.rootAppPath === rootAppPath) {
    return whitelabel.logo
  }
  return G17EcoLogo;
};

const getHomeUrl = (url: match<{ rootAppPath?: string }> | null) => {
  if (homeUrl && url?.params.rootAppPath === rootAppPath) {
    return homeUrl;
  }
  return '/';
}

export const G17EcoHeader = ({ displayRootSwitcher, brandingLogo, routeMatcher, rootInitiatives }: G17EcoHeaderProps) => {
  const currentUser = useAppSelector((state) => state.currentUser);
  const loggedIn = currentUser.loaded;
  const [requestModalOpen, setRequestDemoModalOpen] = useState(false);

  const toggleRequestDemoModal = () => setRequestDemoModalOpen(!requestModalOpen);
  const history = useHistory();

  const url = useRouteMatch<{ rootAppPath?: string }>({ path: '/:rootAppPath/' });
  const logo = getHeaderLogo(brandingLogo, url);
  const homeUrl = getHomeUrl(url);

  return (
      <>
        <div className='g17eco-header-inner'>
          <div className='flex-fill d-flex align-items-center'>
            <div className='ml-1 flex-grow-1'>
              <a href={homeUrl} className={'logo-container logo-sidebar'}>
                <img className={'g17eco-logo'} src={logo} alt='Homepage' />
              </a>
              {displayRootSwitcher ? <OrganizationSwitcher routeMatcher={routeMatcher} rootInitiatives={rootInitiatives}/> :
                <Button color='transparent' size='lg' onClick={() => history.push('/marketplace')} className='ml-3 d-none d-md-inline marketplace-btn text-lg'>
                  Marketplace
                </Button>
              }
            </div>
            {
              loggedIn ?
                <>
                  <div className='help-buttons'>
                    <SimpleTooltip key={'support-hub'} text='Support Hub'>
                      <Button color='link-secondary' onClick={() => window.open('https://wwghelp.zendesk.com', '_blank')}>
                        Support
                      </Button>
                    </SimpleTooltip>
                  </div>
                  <div>
                    <TodoWidget />
                  </div>
                  <div className='p-2 g17eco-header__notification'>
                    <Notifications />
                  </div>
                </> : null
            }
            <div className='user-details'>
              {loggedIn ? <UserDetail /> : <LoginButton toggleRequestDemoModal={toggleRequestDemoModal} />}
            </div>
            <div>
              <AppsMenu toggleRequestDemoModal={toggleRequestDemoModal} />
            </div>
          </div>
        </div>
        <RequestDemoModal
          isOpen={requestModalOpen}
          toggle={toggleRequestDemoModal}
        />
      </>
    );
}
